import { Form, Formik } from "formik";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CommonButton, RippleEffect, Input as TextInput } from "../../..";

export default function ShareBiographyForm({ url, isCopy, setIsCopy, t }) {
  let initialValues = {
    url: url || "",
  };
  return (
    <>
      <Formik initialValues={{ ...initialValues }}>
        {(props) => {
          return (
            <Form>
              <div className="d-flex align-items-end lh-1">
                <div className="form-group mb-0">
                  <label className="form-label lh-sm">
                    {t("text.theme.copyUrl")}
                  </label>
                  <TextInput
                    id="url"
                    name="url"
                    className="form-control"
                    placeholder="Enter Url"
                    disabled
                    setFieldValue={props.handleChange}
                  />
                </div>
                <RippleEffect>
                  <CopyToClipboard
                    text={props.values.url}
                    onCopy={() => setIsCopy(true)}
                  >
                    <CommonButton variant="danger">
                      {!isCopy
                        ? t("text.theme.copyLink")
                        : t("text.theme.copied")}
                    </CommonButton>
                  </CopyToClipboard>
                </RippleEffect>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
